// 客服相關翻譯
export default {
  title: "聯繫客服",
  description: "如需聯繫客服，請掃一掃下方二維碼添加客服。",
  wechatPublic: "微信公眾號",
  wechatCustomer: "微信客服",
  loading: "拼命加載中",
  contactButton: "聯繫客服",
};
